<template>
  <div class="wizard-tab" style="overflow: auto; position: relative; flex: 1;">
    <div id="chatchamp-wizard" />
  </div>
</template>

<script>
// @flow

import { mapGetters, mapState } from 'vuex'

import { logger } from '../../../../common'

const embedWizard = () => import(
  /* webpackChunkName: "embed-wizard" */
  '../../../../wizard/embedWizard.js'
)

export default {
  computed: {
    ...mapGetters(['wizardIntegrationId']),
    ...mapState(['customerId', 'subscriberId', 'parentUrl'])
  },
  mounted (): void {
    if (!this.wizardIntegrationId) return
    embedWizard().then((module) => module.embedWizard({
      customerId: this.customerId,
      subscriberId: this.subscriberId,
      parentUrl: this.parentUrl,
      wizardIntegrationId: this.wizardIntegrationId,
      posthogInstance: this.$posthog
    })).catch(error => {
      logger.error(`Error to load Wizard embedded script: ${error.message}`)
    })
  }
}
</script>
